<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sLYGdG/tc-custom/9781947290488.jpg?1702682477267" alt="This image is the cover for the book Dark Visions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Visions
      </h1>
      <p class="bookDescription body article font2">
        <b>An electrifying thriller from the international bestselling author of <i>The Reckoning</i>, <i>Cain</i>, and <i>Hunter</i>. </b><b>“H</b><b>u</b><b>ggins writes like a man possessed.”—Steve Jackson, <i>New York Times</i> bestselling author</b><br/>  <br/> Joe Mac was a legendary homicide detective until his vision was lost in the line of duty and he was forced into retirement. Now he lives a life of darkness, his only friend being a huge Raven that Joe Mac names “Poe.”<br/><br/> But when Joe Mac’s grandson is murdered by an unknown killer, Joe emerges from his self-imposed solitude to resurrect the skills of the detective he once was. And, although he is blind, Joe Mac begins to hunt down his tiny grandson’s murderer.<br/><br/> Led in some dark way by Poe, Joe Mac relentlessly tracks the murderers of his grandson into the deepest, most dangerous heart of ancient nightmares. And with each haunting step into that darkness, Joe Mac realizes that he has somehow challenged a power that has destroyed nations and conquered continents. And the death they have delivered to the Earth reaches back to the beginning of the world . . .<br/><br/> It is a battle that will take Joe Mac to the edge of sanity and beyond . . .<br/>  <br/><b>Praise for James Byron Huggins</b><br/>  <br/> “May be the thriller of the year.”—<i>BookPage</i> on <i>Cain</i><br/>  <br/> “Pure entertainment.”—<i>Publishers Weekly</i> on <i>Hunter</i><br/>  <br/> “A new action thriller about the ultimate killing machine run amok . . . There’s plenty of guns, explosions, and hand-to-hand combat to keep the story moving along, and a bit of history, conspiracy, and intrigue to fill in the plot.”—<i>SF Site</i> on <i>Cain</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Byron Huggins
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f9125fe2